export default __webpack_public_path__ + "static/media/black-penguin.da309c61.svg";